/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { PushPreview } from 'cio/utils/previews';
import { isEmpty } from '@ember/utils';
import { Platform } from 'cio/models/action';

interface CioPreviewPayloadArgs {
  preview: PushPreview;
  disabled: boolean;
}

export default class CioPreviewPayload extends Component<CioPreviewPayloadArgs> {
  @tracked isShowingPayloadModal = false;
  @tracked selectedPlatform = Platform.iOS;

  get payloadSnippet() {
    if (this.selectedPlatform === Platform.iOS) {
      return JSON.stringify(this.iosPayload, null, 2);
    }
    return JSON.stringify(this.androidPayload, null, 2);
  }

  get bothPlatformsPresent() {
    return !isEmpty(this.androidPayload) && !isEmpty(this.iosPayload);
  }

  get androidPayload() {
    return this.args.preview?.payload.android;
  }

  get iosPayload() {
    return this.args.preview?.payload.ios;
  }

  get provider() {
    if (this.selectedPlatform === Platform.iOS && this.args.preview?.ios_provider === 'apns') {
      return {
        title: 'APPLE PUSH NOTIFICATION SERVICE',
        icon: new URL('cio/assets/images/push-providers/apns.png', import.meta.url).toString(),
      };
    }
    return {
      title: 'FIREBASE CLOUD MESSAGING',
      icon: new URL('cio/assets/images/push-providers/fcm.png', import.meta.url).toString(),
    };
  }

  @action
  onPlatformChange(platform: Platform) {
    this.selectedPlatform = platform;
  }

  @action
  showPayloadModal() {
    // presence of at least one of the two payloads is guaranteed
    // as the component is only rendered if push is enabled
    // if both platforms are present we'd like to keep the state of modal
    if (!this.bothPlatformsPresent) {
      this.selectedPlatform = isEmpty(this.androidPayload) ? Platform.iOS : Platform.Android;
    }
    this.isShowingPayloadModal = true;
  }
}
